module.exports = __webpack_public_path__ + "img/lera-work-1.d320818c.jpg";